import React from "react";
import { motion } from "framer-motion";
import styled from "styled-components";

const HN = styled("h1")({
	fontSize: 30,
	color: "#F8F9FA",
	letterSpacing: 2,
	"&: hover>span": {
		animation: "flicker 1s linear infinite",
	},
});
const HS = styled("h2")({
	fontSize: 15,
	fontFamily: "'Ubuntu', sans-serif",
	color: "#F8F9FA",
});

const Neontag = ({heading, subheading, delay, flicker}) => {
  return (
    <>
        <HN
		    as={motion.div}
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			transition={{
			    duration: 0.5,
				type: "spring",
				delay: delay,
            }}
			>
			<span className={flicker ? "neon flicker-fast": "neon"}>{heading.substring(0,1)}</span>{heading.substring(1, heading.length)}
			</HN>
			<HS
				as={motion.div}
				initial={{ opacity: 0 }}
				animate={{ opacity: 1 }}
				transition={{
				    duration: 0.5,
					type: "spring",
					delay: delay,
				}}
				>
				{subheading}
			</HS>
    </>
  )
}

export default Neontag